import { useState } from "react"
import "./contactForm.css"
import axios from "axios"
import isMobilePhone from 'validator/lib/isMobilePhone';
import { ToastContainer, toast } from 'react-toastify';
const ContactForm=()=>{
  const Done = () => toast.success("Message sent successfully!");
  const NotDone = () => toast.error("All fields are required")
    const ErrorNotif = () => toast.error("Failed to send message")
  const [loader,setLoader]=useState(false)
   const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  const [data,setData]=useState({
    name:"",
    email:"",
    contact:"",
    message:"",
    subject:""
  })
    const [error, setError] = useState({
   name:"",
    email:"",
    contact:"",
    message:"",
    subject:""
  });
  const handleData=(e)=>{
setData((prev)=>({...prev,
   [e.target.name]: e.target.value
   
}))
 setError({
    ...error,
    [e.target.name]:""
   }) 
   }

    const handleSubmit = async (e) => {
    e.preventDefault();
    let isValid = true;
    let newError = {};

    if(!data.name){
      newError.name="Please Enter The Name"
      isValid=false
    }
    else if(data.name.length<=2){
       newError.name="Please Enter The Valid Name"
       isValid=false
    }

    if(!data.email){
      newError.email="Please Enter The Email"
      isValid=false
    }
    else if(!emailRegex.test(data.email)){
      newError.email="Please Enter Valid Email"
      isValid=false
    }

    if (!data.contact) {
      newError.contact = "Please Enter The Contact";
      isValid = false;
    } else if (!isMobilePhone(data.contact, 'en-IN')) {
      newError.contact = "Please Enter a Valid Mobile Number";
      isValid = false;
    }


    if(!data.message){
      newError.message="Please Enter The Message"
      isValid=false
    }

      if(!data.subject){
      newError.subject="Please Enter The Subject"
      isValid=false
    }
   
   
    setError(newError);
try{
    if(isValid){
      setLoader(true)
   console.log("data",data)
      await axios.post("https://bestdealelectricalsbackend.onrender.com/bestdealelectricals/email",data)
     setData({
         name:"",
    email:"",
    contact:"",
    message:"",
    subject:""
        });
     Done()
      window.location.reload()
    }
    else{
   NotDone()
    }}
    catch(error){
      ErrorNotif()}
      setLoader(false)
      console.log("error",error || error.msg)
  }

    return(<>
<form className="form py-4 px-auto">
<h2 className="pb-3">Let's Stay Connected</h2>
 <div className=" position-relative my-4">
            <label htmlFor="name" className="category-label">
            Name
            </label>
            <input
              type="name"
              className="category-input"
              name="name"
              value={data.name}
              onChange={handleData}
            />
            {error.name && <p className="error">{error.name}</p>}
          </div>
           <div className=" position-relative my-4">
            <label htmlFor="Contact" className="category-label">
             Contact
            </label>
            <input
              type="text"
              className="category-input"
              name="contact"
              value={data.contact}
              onChange={handleData}
            />
            {error.contact && <p className="error">{error.contact}</p>}
          </div>
   <div className=" position-relative my-4">
            <label htmlFor="email" className="category-label">
             Email
            </label>
            <input
              type="email"
              className="category-input"
              name="email"
              value={data.email}
              onChange={handleData}
            />
            {error.email && <p className="error">{error.email}</p>}
          </div>
           <div className=" position-relative my-4">
            <label htmlFor="subject" className="category-label">
             Subject
            </label>
            <input
              type="text"
              className="category-input"
              name="subject"
              value={data.subject}
              onChange={handleData}
            />
            {error.subject && <p className="error">{error.subject}</p>}
          </div>
            <div className=" position-relative my-4">
            <label htmlFor="message" className="category-label">
             Message
            </label>
            <textarea
              type="text"
              className="category-input"
              name="message"
              value={data.message}
              onChange={handleData}
            />
            {error.message && <p className="error">{error.message}</p>}
          </div>
         <div className="text-center">  {loader ? (<><div className="loader p-0 my-0"></div></>) : (<><button className="button" onClick={handleSubmit}>Submit</button></>)}</div>
</form>
 <ToastContainer />
    </>)
}
export default ContactForm